/**
 * Better Auth browser client: sign-in, sign-out and the session. The API's
 * `customSession` makes `getSession` return the platform's caller (see `useSession`).
 *
 * Better Auth needs an absolute base URL: the app and API are cross-origin.
 */
import { passkeyClient } from '@better-auth/passkey/client';
import { ssoClient } from '@better-auth/sso/client';
import { twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

import { API_URL } from '@/lib/http';

const authClient = createAuthClient({
   baseURL: `${API_URL}/api/auth`,
   plugins: [ssoClient(), twoFactorClient(), passkeyClient()]
});

export const { getSession, signIn, signOut, requestPasswordReset, resetPassword, twoFactor, passkey } = authClient;
